import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Switch, Tooltip, Typography } from "@mui/material"
import { getTaskPreferences, updateTaskPreferences } from "api/services/preferencess";
import BottomBar from "components/BottomBar";
import { snack } from "components/toast";
import { UserProfileContext } from "context/UserProfile";
import { useContext, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { handleError } from "utils/handleError";
import Announcement from "./../../../assets/images/Announcement.svg";
import CheckInInfo from "views/settings/preferences/CheckInInfo";

const LogHourPreferences = () => {
    const queryClient = useQueryClient();
    const { data: uData } = useContext(UserProfileContext);
    const [originalState, setOriginalState] = useState<any>(
        {
            loghours: false,
            logHoursDate: 1,
            previousDayDate: 1,
            isPrevious: false,
            isDescription: false,
            isEmailSend: false,
            isGeneralButtonShow: true,
            isClockTimeShow: false,
            isTaskLeader: false,
            isAllowTimesheetCompleteTask: false,
            completeTaskDays: 1,
            isCheckEmployee: false,
            isGeneralDShow: false

        });
    const [task, setTask] = useState<any>(
        {
            loghours: false,
            logHoursDate: 1,
            previousDayDate: 1,
            isPrevious: false,
            isDescription: false,
            isEmailSend: false,
            isGeneralButtonShow: false,
            isClockTimeShow: false,
            isTaskLeader: false,
            isAllowTimesheetCompleteTask: false,
            completeTaskDays: 1,
            isCheckEmployee: false,
            isGeneralDShow: false

        });
    const [openInfo, setOpenInfo] = useState(false);


    const { isLoading: queryLoading } = useQuery(["task-preferenecs", uData?.id], getTaskPreferences, {
        onSuccess: (res: any) => {
            // setTask(res?.data?.taskPreferences);

            if (res?.data?.taskPreferences) {
                setTask((prev) => ({
                    ...prev,
                    ...res?.data?.taskPreferences
                }));
                setOriginalState((prev) => ({
                    ...prev,
                    ...res?.data?.taskPreferences
                }))
            }
        }
    })

    const { data, mutate, isLoading } = useMutation(updateTaskPreferences, {
        onSuccess: () => {
            snack.success("Task Preferences Updated!");
            queryClient.invalidateQueries("task-preferenecs");
        },
        onError: (err: any) => {
            snack.error(handleError(err));
        },
    });

    const handleUpdatePermissons = async () => {
        const data = { ...task };
        mutate({ data: { taskPreferences: data } });

    };

    return (
        <Box m={2}>
            <>
                <Grid container mt={2}>
                    <Grid item xs={7}>
                        <Typography variant="body1">Is it mandatory for employees in the organization to add descriptions for every timesheet entry?</Typography>

                    </Grid>
                    <Grid item xs={3}>
                        <Box display="flex" alignItems="center">
                            <Switch
                                onChange={() => setTask({ ...task, isDescription: !task?.isDescription })}
                                checked={task?.isDescription}
                                sx={{ marginRight: "25px" }}
                            />
                            <Typography>{task?.isDescription ? "On" : "Off"}</Typography>
                        </Box>
                    </Grid>
                </Grid>


            </>

            <Grid container mt={2}>
                <Grid item xs={7}>
                    <Typography variant="body1" > Should employees in the organisation be able to add log hours for the Previous Day?</Typography>

                </Grid>
                <Grid item xs={3}>
                    <Box display="flex" alignItems="center">
                        <Switch
                            onChange={() => setTask({ ...task, isPrevious: !task?.isPrevious })}
                            checked={task?.isPrevious}
                            sx={{ marginRight: "25px" }}
                        />
                        <Typography>{task?.isPrevious ? "On" : "Off"}</Typography>
                    </Box>
                </Grid>
            </Grid>


            <Box mt={2}>
                {task?.isPrevious && (
                    <>
                        <Grid container mt={3} ml={5}>
                            <Grid item xs={7}>
                                <Typography >How many days should employees be allowed to add log hours?</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl >
                                    <InputLabel>Duration</InputLabel>
                                    <Select
                                        size="small"
                                        placeholder="previousDayPrefenences"
                                        labelId="Previous Days Prefenences"
                                        id="previousDayprefernces"
                                        value={task?.previousDayDate || null}
                                        onChange={(value) => {
                                            setTask({ ...task, previousDayDate: value.target.value })
                                        }}
                                        label="Previous Days Preferences"
                                    >
                                        <MenuItem key={"one"} value={1}>
                                            One Day
                                        </MenuItem>
                                        <MenuItem key={"three"} value={3}>
                                            Three Days
                                        </MenuItem>
                                        <MenuItem key={"week"} value={7}>
                                            One Week
                                        </MenuItem>
                                        <MenuItem key={"15"} value={15}>
                                            15 Days
                                        </MenuItem>
                                        <MenuItem key={"30"} value={30}>
                                            30 Days
                                        </MenuItem>
                                        <MenuItem key={"60"} value={60}>
                                            60 Days
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                    </>
                )}
            </Box>



            <Grid container mt={2}>
                <Grid item xs={7}>
                    <Typography variant="body1" >Should employees in the organisation be able to add log hours for completed tasks?</Typography>

                </Grid>
                <Grid item xs={3}>
                    <Box display="flex" alignItems="center">
                        <Switch
                            onChange={() => setTask({ ...task, isAllowTimesheetCompleteTask: !task?.isAllowTimesheetCompleteTask })}
                            checked={task?.isAllowTimesheetCompleteTask}
                            sx={{ marginRight: "25px" }}
                        />
                        <Typography>{task?.isAllowTimesheetCompleteTask ? "On" : "Off"}</Typography>
                    </Box>
                </Grid>
            </Grid>


            <Box mt={2}>
                {task?.isAllowTimesheetCompleteTask && (
                    <>
                        <Grid container mt={3} ml={5}>
                            <Grid item xs={7}>
                                <Typography >How many days should employees be allowed to add log hours after the task is completed?</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl >
                                    <InputLabel>Duration</InputLabel>
                                    <Select
                                        size="small"
                                        placeholder="completeDayPreferences"
                                        labelId="complte Days Prefenences"
                                        id="completeDaypreferences"
                                        value={task?.completeTaskDays || null}
                                        onChange={(value) => {
                                            setTask({ ...task, completeTaskDays: value.target.value })
                                        }}
                                        label="complete Days Preferences"
                                    >
                                        <MenuItem key={"one"} value={1}>
                                            One Day
                                        </MenuItem>

                                        <MenuItem key={"week"} value={7}>
                                            One Week
                                        </MenuItem>
                                        <MenuItem key={"15"} value={15}>
                                            15 Days
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                    </>
                )}
            </Box>


            <Grid container mt={2}>

                <Grid item xs={7}>
                    <Typography variant="body1" > Do you want to enable daily timesheet email notifications?</Typography>

                </Grid>
                <Grid item xs={3}>
                    <Box display="flex" alignItems="center">
                        <Switch
                            onChange={() => setTask({ ...task, isEmailSend: !task?.isEmailSend })}
                            checked={task?.isEmailSend}
                            sx={{ marginRight: "25px" }}
                        />
                        <Typography>{task?.isEmailSend ? "On" : "Off"}</Typography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mt={2}>

                <Grid item xs={7}>
                    <Typography variant="body1" > Do you want Partner/Task Leaders as Approval Managers?</Typography>

                </Grid>
                <Grid item xs={3}>
                    <Box display="flex" alignItems="center">
                        <Switch
                            onChange={() => setTask({ ...task, isTaskLeader: !task?.isTaskLeader })}
                            checked={task?.isTaskLeader}
                            sx={{ marginRight: "25px" }}
                        />
                        <Typography>{task?.isTaskLeader ? "On" : "Off"}</Typography>
                    </Box>
                </Grid>
            </Grid>

            <Grid container mt={2}>

                <Grid item xs={7}>
                    <Typography variant="body1" > Do you want to Show General Time sheet?</Typography>

                </Grid>
                <Grid item xs={3}>
                    <Box display="flex" alignItems="center">
                        <Switch
                            onChange={() => setTask({ ...task, isGeneralButtonShow: !task?.isGeneralButtonShow })}
                            checked={task?.isGeneralButtonShow}
                            sx={{ marginRight: "25px" }}
                        />
                        <Typography>{task?.isGeneralButtonShow ? "On" : "Off"}</Typography>
                    </Box>
                </Grid>

            </Grid>

            <Grid container mt={2}>

                <Grid item xs={7}>
                    <Typography variant="body1" > Do you want to Show Only Clock in Time sheet?</Typography>

                </Grid>
                <Grid item xs={3}>
                    <Box display="flex" alignItems="center">
                        <Switch
                            onChange={() => setTask({ ...task, isClockTimeShow: !task?.isClockTimeShow })}
                            checked={task?.isClockTimeShow}
                            sx={{ marginRight: "25px" }}
                        />
                        <Typography>{task?.isClockTimeShow ? "On" : "Off"}</Typography>
                    </Box>
                </Grid>

            </Grid>

            <Grid container mt={2}>

                <Grid item xs={7}>
                    <Typography variant="body1" > Require completion of the last working day’s timesheet as a prerequisite for current day check-in?</Typography>

                </Grid>
                <Grid item xs={3}>
                    <Box display="flex" alignItems="center">
                        <Switch
                            onChange={() => setTask({ ...task, isCheckEmployee: !task?.isCheckEmployee })}
                            checked={task?.isCheckEmployee}
                            sx={{ marginRight: "25px" }}
                        />
                        <Typography>{task?.isCheckEmployee ? "On" : "Off"}</Typography>
                        <Button
                            onClick={() => setOpenInfo(true)}
                            sx={{
                                backgroundColor: "#fff",
                                "&:hover": { backgroundColor: "#fff" },
                                p: 0,
                                ml: 1,
                                minWidth: "auto",
                            }}
                        >
                            <Tooltip title="Announcement">
                                <img
                                    src={Announcement}
                                    alt="Announcement"
                                    style={{ cursor: "pointer", width: 33, height: 33 }}
                                />
                            </Tooltip>
                        </Button>
                        <CheckInInfo open={openInfo} setOpen={setOpenInfo} />

                    </Box>
                </Grid>

            </Grid>

            <Grid container mt={2}>

                <Grid item xs={7}>
                    <Typography variant="body1" > Do you want to display the timesheet description in the table column?</Typography>

                </Grid>
                <Grid item xs={3}>
                    <Box display="flex" alignItems="center">
                        <Switch
                            onChange={() => setTask({ ...task, isGeneralDShow: !task?.isGeneralDShow })}
                            checked={task?.isGeneralDShow}
                            sx={{ marginRight: "25px" }}
                        />
                        <Typography>{task?.isGeneralDShow ? "On" : "Off"}</Typography>
                    </Box>
                </Grid>

            </Grid>

            <Grid item xs={12} mt={2}>
                <Typography variant="h6" color="secondary" display="inline" fontSize={18}>Note:</Typography>
                <Typography variant="inherit" color="#000000" fontWeight={"700"} mt={0.5} fontSize={13}>
                    Employees cannot add log hours for Deleted / Terminated Task
                </Typography>
                <Typography variant="inherit" color="#000000" fontWeight={"700"} mt={0.5} fontSize={13}>
                    They can add log hours for the task which are created and in the status of Todo, In Progress, On Hold, Under Review
                </Typography>
                <Typography variant="inherit" color="#000000" fontWeight={"700"} mt={0.5} fontSize={13}>
                    Where as for the Completed Task for the purpose of Timesheet, it will be Archived only after the time set within the preference, which won't consider the preference set for the Dashboard & Taskboard
                </Typography>
            </Grid>
            <BottomBar
                isLoading={isLoading}
                data={originalState}
                state={task}
                onCancel={() => setTask(originalState)}
                onUpdate={handleUpdatePermissons}
            />
        </Box>
    )
}

export default LogHourPreferences